import { render, staticRenderFns } from "./FacilityEditGeolocation.vue?vue&type=template&id=80b9b4ce&"
import script from "./FacilityEditGeolocation.vue?vue&type=script&lang=js&"
export * from "./FacilityEditGeolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports